import { render, staticRenderFns } from "./HoverButton.vue?vue&type=template&id=066a6116"
import script from "./HoverButton.vue?vue&type=script&lang=js"
export * from "./HoverButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports